<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Operation Activities</v-stepper-step>

     <!--  <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Implementing Agency</v-stepper-step> -->

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">IDA Funding</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" step="3">Project Components</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step step="4">Project Document</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <OperationActivitiesForm v-on:emitForm1="goNextStep"></OperationActivitiesForm>
      </v-stepper-content>

      <!-- <v-stepper-content step="2">
        <ImplementingAgency v-on:emitForm2="goNextStep"></ImplementingAgency>
      </v-stepper-content> -->

      <template v-if="e1==2">
      <v-stepper-content step="2">
        <DevelopmentPartner v-on:emitForm3="goNextStep"></DevelopmentPartner>
      </v-stepper-content>
      </template>

      <template v-if="e1==3">
      <v-stepper-content step="3">
        <ProjectComponents v-on:emitForm4="goNextStep"></ProjectComponents>
      </v-stepper-content>
      </template>

      <template v-if="e1==4">
      <v-stepper-content step="4">
        <ProjectDocument v-on:emitForm5="goNextStep"></ProjectDocument>
      </v-stepper-content>
      </template>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
let commonService = require("../../../services/common.service");
import OperationActivitiesForm from './step_forms/operationActivitiesForm';
//import ImplementingAgency from './step_forms/implementingAgency';
import DevelopmentPartner from './step_forms/developmentPartner';
import ProjectComponents from './step_forms/projectComponents';
import ProjectDocument from './step_forms/projectDocument';
export default {
  components: {
    OperationActivitiesForm,
    //ImplementingAgency,
    DevelopmentPartner,
    ProjectComponents,
    ProjectDocument,
  },
  data() {
    return {
      e1: 0,

      formSchema: {
        pro_code: "",
        pro_start_date: "",
        pro_name: "",
        pro_name: "",
        pro_end_date: "",
        pro_objectives: "",
        pro_location: "",
        total_pro_v: "",
        adp_code: "",
        total_pro_v2: "",
        non_adp_code: "",
        pro_agreement_date: "",
        agreement_ministry: ""
      }
    };
  },
  created() {
   
  },
  methods:{
    submitOperationActivities()
    {      
      commonService.insertFormData(formSchema, "partner-info").then(res => {           
            if(res.status==1) {
              this.e1 = 2
            }
          });
    },

    goNextStep(num)
    {
      this.e1 = num
    }
  },

};
</script>


// WEBPACK FOOTER //
// src/components/project_info/operation_activities/activitiesForm.vue